module.exports = __webpack_public_path__ + "img/hacker.41c7bc8d.jpg";